import React, { PureComponent } from 'react';
import { ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, element, expression, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isEmptyOrBlankString } from '@philips-internal/oswald-ui-utils';
import './option-group.css';
const acceptedTypes = [
    ComponentType.NAVIGATION,
];
// TODO: Due to lack of design spec for mobile, for now this component won't be available on Oswald.
class OptionGroup extends PureComponent {
    renderTitle() {
        const { title = '' } = this.props;
        if (isEmptyOrBlankString(title)) {
            return null;
        }
        return (React.createElement("div", { className: "c-option-group__title" }, MessageService.translate(title)));
    }
    renderContent() {
        const { children, uuid } = this.props;
        return (React.createElement(Container, { acceptedTypes: acceptedTypes, className: "c-option-group__content", uuid: uuid }, children));
    }
    render() {
        return (React.createElement("div", { className: "c-option-group" },
            this.renderTitle(),
            this.renderContent()));
    }
}
OptionGroup.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    title: expression,
    uuid: string,
};
export { OptionGroup, };
export default OptionGroup;
//# sourceMappingURL=option-group.js.map